// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1_WhG","right":"styles_right__1Q-7X"};